/** Theme preference: light, dark, or follow the system (the Teams client theme inside Teams, the OS `prefers-color-scheme` in a browser; wired in App.tsx). */
export type ThemeMode = 'light' | 'dark' | 'system'

export const THEME_MODES: ThemeMode[] = ['light', 'system', 'dark']

const STORAGE_KEY = 'trg-theme-mode'

export function getStoredThemeMode(): ThemeMode {
  try {
    const value = localStorage.getItem(STORAGE_KEY)
    if (value === 'light' || value === 'dark' || value === 'system') return value
  } catch {
    // localStorage can throw in locked-down iframes; fall back to system.
  }
  return 'system'
}

export function storeThemeMode(mode: ThemeMode): void {
  try {
    localStorage.setItem(STORAGE_KEY, mode)
  } catch {
    // Non-fatal: the choice just won't persist.
  }
}

export function resolveIsDark(mode: ThemeMode, systemIsDark: boolean): boolean {
  if (mode === 'system') return systemIsDark
  return mode === 'dark'
}

/** The phone's status bar matches the app's top bar: white, or slate-800. */
export function themeColorFor(isDark: boolean): string {
  return isDark ? '#1d293d' : '#ffffff'
}

/** Stamp <html data-theme> so Tailwind's dark variant and the Toaster follow it. */
export function applyTheme(isDark: boolean): void {
  document.documentElement.dataset.theme = isDark ? 'dark' : 'light'
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', themeColorFor(isDark))
}
